/** 捐赠类型 - 梦想值捐赠 */
export const DREAM_POINT = "DREAM_POINT"; //梦想值捐赠

/** 捐赠类型 - 交易值捐赠 */
export const TRADING_LOT = "TRADING_LOT"; //交易值捐赠

/** 我的捐赠 - 全部 */
export const ALL_DONATION = "ALL_DONATION"; //全部

/** 我的捐赠 - 梦想值捐赠 */
export const DREAM_VALUE_DONATION = "DREAM_VALUE_DONATION"; //梦想值捐赠

/** 我的捐赠 - 交易值捐赠 */
export const TRADING_DONATION = "TRADING_DONATION"; //交易值捐赠

// tab Type
export const POINTS = "points";
export const DONATION = "donation";
export type TabType = typeof POINTS | typeof DONATION;
